import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { FrontComponent } from './front/front.component';
import { CloudPbxComponent } from './cloud-pbx/cloud-pbx.component';
import { OnPremiseComponent } from './on-premise/on-premise.component';
import { ContactComponent } from './contact/contact.component';
import { ExtraComponentsComponent } from './extra-components/extra-components.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ApiProviderService } from './services/api-provider.service';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    FrontComponent,
    CloudPbxComponent,
    OnPremiseComponent,
    ContactComponent,
    ExtraComponentsComponent
  ],
  imports: [
    BrowserModule,
    NgbModule.forRoot(),
    FormsModule,
    RouterModule,
    AppRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    HttpClientModule
  ],
  providers: [
    ExtraComponentsComponent,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ApiProviderService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
